import { render, staticRenderFns } from "./NavireDossier.vue?vue&type=template&id=d1fa2b8c&scoped=true&"
import script from "./NavireDossier.js?vue&type=script&lang=js&"
export * from "./NavireDossier.js?vue&type=script&lang=js&"
import style0 from "./NavireDossier.vue?vue&type=style&index=0&id=d1fa2b8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1fa2b8c",
  null
  
)

export default component.exports